import classNames from 'classnames';

import { QUESTION_TYPES } from '@api/instant_survey';
import type { Question, ScreenerQuestionBank } from '@api/instant_survey/types';
import { Button, Card, RadioButtonIcon } from '@utilities';

import styles from './_index.module.scss';

interface BankViewProps {
  bank: ScreenerQuestionBank;
  onPreviewQuestion: (question: Question) => void;
}

const getQuestionTypeLabel = (type: string) => {
  if (type === QUESTION_TYPES.RADIO.value) return QUESTION_TYPES.RADIO.name;
  return type;
};

const BankView = ({ bank, onPreviewQuestion }: BankViewProps) => (
  <div className={styles['bank-view-grid']}>
    {bank.questions.length === 0 && (
      <p className={styles['bank-view-empty']}>
        There are no screener questions available for this bank yet.
      </p>
    )}
    {bank.questions.map((question) => {
      const hasScreenerLabel = Boolean(question.screenerLabel);

      return (
        <div className={styles['bank-view-card-wrapper']} key={question.id}>
          <Card className={styles['bank-view-card']} padding="large">
            <div>
              <span
                className={classNames(styles['bank-view-title'], {
                  [styles['bank-view-title-bold']]: hasScreenerLabel,
                })}
              >
                {hasScreenerLabel ? question.screenerLabel : question.text}
              </span>
              {hasScreenerLabel && (
                <p className={styles['bank-view-description']}>{question.text}</p>
              )}
            </div>
            <div className={styles['bank-view-footer']}>
              <span>
                <RadioButtonIcon />
                {getQuestionTypeLabel(question.type)}
              </span>
              <Button
                onClick={() => onPreviewQuestion(question)}
                text="Preview"
                variant="secondary"
              />
            </div>
          </Card>
        </div>
      );
    })}
  </div>
);

export default BankView;
